import { motion, useReducedMotion } from "framer-motion";

const OFFSETS = {
    up: { y: 28, x: 0 },
    down: { y: -28, x: 0 },
    left: { y: 0, x: 32 },
    right: { y: 0, x: -32 },
    none: { y: 0, x: 0 },
};

export const Reveal = ({
    children,
    delay = 0,
    className = "",
    from = "up",
    blur = true,
}) => {
    const reduce = useReducedMotion();
    const off = OFFSETS[from] || OFFSETS.up;
    return (
        <motion.div
            className={className}
            initial={
                reduce
                    ? false
                    : { opacity: 0, ...off, filter: blur ? "blur(6px)" : "blur(0px)" }
            }
            whileInView={{ opacity: 1, y: 0, x: 0, filter: "blur(0px)" }}
            viewport={{ once: true, margin: "-70px" }}
            transition={{ duration: 0.75, delay, ease: [0.16, 1, 0.3, 1] }}
        >
            {children}
        </motion.div>
    );
};

export const Stagger = ({ children, className = "", delay = 0 }) => (
    <motion.div
        className={className}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, margin: "-70px" }}
        variants={{
            hidden: {},
            show: { transition: { staggerChildren: 0.09, delayChildren: delay } },
        }}
    >
        {children}
    </motion.div>
);

export const StaggerItem = ({ children, className = "", ...rest }) => {
    const reduce = useReducedMotion();
    return (
        <motion.div
            className={className}
            variants={{
                hidden: reduce ? {} : { opacity: 0, y: 26, filter: "blur(6px)" },
                show: {
                    opacity: 1,
                    y: 0,
                    filter: "blur(0px)",
                    transition: { duration: 0.7, ease: [0.16, 1, 0.3, 1] },
                },
            }}
            {...rest}
        >
            {children}
        </motion.div>
    );
};
